export interface VideoSource {
  type: string;
  url: string;
}

interface VideoWithFallbackProps {
  className?: string;
  sources: VideoSource[];
  poster: string;
  alt: string;
}

export function VideoWithFallback({
  className,
  sources,
  alt,
  poster,
}: VideoWithFallbackProps) {
  return (
    <video
      className={className}
      autoPlay
      muted
      loop
      playsInline
      poster={poster}
      aria-label={alt}
    >
      {sources.map(({ type, url }) => (
        <source key={url} src={url} type={`video/${type}`} />
      ))}
    </video>
  );
}
